import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { MeterGroupModule } from 'primeng/metergroup';
import { MultiSelectModule } from 'primeng/multiselect';
import { PopoverModule } from 'primeng/popover';
import {
  ProgressSpinner,
  ProgressSpinnerModule,
} from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';

import { environment } from '@environments/environment';

@Component({
  selector: 'data-studio',
  standalone: true,
  imports: [
    RouterModule,
    ButtonModule,
    SelectButtonModule,
    FormsModule,
    SelectModule,
    InputTextModule,
    DatePickerModule,
    TextareaModule,
    CheckboxModule,
    PopoverModule,
    TableModule,
    AccordionModule,
    ProgressSpinnerModule,
    MeterGroupModule,
    MultiSelectModule,
    TagModule,
    ToastModule,
    ProgressSpinner,
  ],
  templateUrl: './data-studio-loader.component.html',
  styles: ``,
})
export class DataStudioLoaderComponent {
  value = signal('overview');

  routes: { label: string; value: string }[] = [
    { label: $localize`Overview`, value: 'overview' },
    { label: $localize`Contracts`, value: 'contracts' },
  ];
  constructor() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${environment.REMOTE_URL_DATA_STUDIO}/styles.css`;
    document.head.appendChild(link);
  }
}
